module.exports = __webpack_public_path__ + "img/weibo.7a6db423.png";